var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isEmpty(_vm.user))?_c('HOMEPAGE'):_c('DASHBOARD')],1)}
var staticRenderFns = []

export { render, staticRenderFns }